import { render, staticRenderFns } from "./ConfirmStepView.vue?vue&type=template&id=7f35d3e0&scoped=true"
import script from "./ConfirmStepView.vue?vue&type=script&lang=js"
export * from "./ConfirmStepView.vue?vue&type=script&lang=js"
import style0 from "./ConfirmStepView.vue?vue&type=style&index=0&id=7f35d3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35d3e0",
  null
  
)

export default component.exports